import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Redirect} from 'react-router';
import {connect} from 'react-redux';
import * as Actions from '../actions';
import Lightbox from 'react-images';
import Settings from '../lib/settings';

class Product extends Component {

  constructor(props) {
    super(props);
    this.state = {
      clickedAddToCart: false,
      currentImage: 0,
      lightboxIsOpen: false,
      product: {
        name: "",
        description: "",
        price: "",
        discount: "",
        images: [""],
        slug: "",
        parameters: [],
        isUnmounted: true
      },
      selectedParameters: [],
      addAmount: 1,
      ok: true

    };
    this.imagesHandler = this.imagesHandler.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.handleAddAmount = this.handleAddAmount.bind(this);
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.handleParameterChange = this.handleParameterChange.bind(this);
  }

  componentDidMount() {
    //this.props.dispatch(Actions.loader(true));
    fetch('/api/product/' + this.props.match.params.slug, Settings.fetchParams('GET')).then(res => res.json()).then(json => {
      this.props.dispatch(Actions.loader(false));
      if (json === null) {
        this.setState({product: json, ok: false});
      } else {
        this.setState({product: json, ok: true});
      }
    });
    window.scrollTo(0, this.props.menuPosition);
  }

  componentWillUnmount() {this.isUnmounted = true;}

  openLightbox() {
    this.setState({lightboxIsOpen: true});
  }
  closeLightbox() {
    this.setState({lightboxIsOpen: false});
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1
    });
  }

  imagesHandler(src, index) {
    ReactDOM.findDOMNode(this.refs.bigImage).src = "/img/products/" + src;
    ReactDOM.findDOMNode(this.refs.bigImage2).src = "/img/products/" + src;
    this.setState({currentImage: index});
  }

  handleImageLoaded(event) {
    event.target.classList.remove("imageLoading");
  }

  handleAddAmount(event) {
    this.setState({addAmount: event.target.value});
  }

  handleParameterChange(event, index) {
    let selectedParameters = this.state.selectedParameters;
    selectedParameters[index] = event.target.value;
    this.setState({selectedParameters: selectedParameters});
  }

  handleAddToCart(event) {
    if (!this.state.clickedAddToCart) {

      setTimeout(() => {
        if(!this.isUnmounted) {
          this.setState({clickedAddToCart: false});
        }

      }, 3500);
      let parameters = [];
      let errors = 0;
      this.setState({clickedAddToCart: true});
      if (typeof this.state.product.parameters !== "undefined") {
        this.state.product.parameters.forEach((item, index) => {
          if (typeof this.state.selectedParameters[index] === "undefined") {
            errors++;
          } else {
            let selectedParameterIndex = this.state.selectedParameters[index];
            parameters.push({name: item.name, value: item.values[selectedParameterIndex]});
          }
        });
      }

      if (errors > 0) {
        alert("Prosím vyberte parametry produktu.");
        this.setState({clickedAddToCart: false});
      } else {

        let product = {
          _id: this.state.product._id,
          price: this.state.product.price,
          amount: this.state.addAmount,
          slug: this.state.product.slug,
          parameters: parameters
        };

        //this.props.dispatch(Actions.addToCart(product));

        fetch("/api/cart", Settings.fetchParams('POST', product)).then(res => {
          if (res.ok) {
            res.json().then(json => {

              if (!json.error && json.products) {
                this.props.dispatch(Actions.updateCart(json.products));
                ReactDOM.findDOMNode(this.refs.addedToCart).style.opacity = 1;
                ReactDOM.findDOMNode(this.refs.addedToCart).style.zIndex = 3;

                setTimeout(() => {
                  if(ReactDOM.findDOMNode(this.refs.addedToCart) !== null) {
                    ReactDOM.findDOMNode(this.refs.addedToCart).style.opacity = 0;
                    ReactDOM.findDOMNode(this.refs.addedToCart).style.zIndex = 0;
                  }

                }, 3000);
              } else {
                alert("Chyba při přidávání do košíku");
              }
            })
          } else {
            alert("Chyba2 při přidávání do košíku");
          }
        });

      }
    }
  }

  render() {

    if (!this.state.ok) {
      return <Redirect to="/"/>;
    }

    const content = this.state.product.description;
    function createMarkup() {
      return {__html: content};
    };

    const aImages = this.state.product.images.map((item, index) => <div key={index} className="additionalImage" onClick={() => this.imagesHandler(item, index)}>
      <div className="square">
        <div className="squareContent">{
            typeof item === "undefined"
              ? ""
              : <img src={"/img/products/" + item} alt="" className="imageLoading" onLoad={this.handleImageLoaded}/>
          }</div>
      </div>
    </div>);

    let Parameters = "";

    if (typeof this.state.product.parameters !== "undefined") {
      Parameters = this.state.product.parameters.map((item, index) => {

        let selectedParameter = typeof this.state.selectedParameters[index] === "undefined"
          ? "default"
          : this.state.selectedParameters[index];

        return (<div className="producParameter" key={index}>
          <p>{item.name}</p>
          <div className="selectWrapper">
            <select value={selectedParameter} onChange={(e) => {
                this.handleParameterChange(e, index)
              }}>
              <option disabled="disabled" value="default">Vyberte</option>
              {item.values.map((item2, index2) => <option value={index2} key={index2}>{item2}</option>)}
            </select>
          </div>
        </div>)
      });
    }

    const images = this.state.product.images.map((item, index) => {
      return {
        src: "/img/products/" + item
      }
    });

    return (<div className="overflowHidden">
      <div className="productDetails">
        <Lightbox images={images} onClose={this.closeLightbox} onClickPrev={this.gotoPrevious} onClickNext={this.gotoNext} currentImage={this.state.currentImage} isOpen={this.state.lightboxIsOpen}/>
        <div className="col50 desktopProductDetailsImage">
          <div className="square">
            <div className="squareContent">{
                typeof this.state.product.images[0] === "undefined"
                  ? ""
                  : <img ref="bigImage" alt="" className="imageLoading" src={"/img/products/" + this.state.product.images[0]} onClick={this.openLightbox} onLoad={this.handleImageLoaded}/>
              }</div>
          </div>
          <div>{aImages}</div>
        </div>
        <div className="col50">
          <div className="productInformationWrapper">
            <h1>{this.state.product.name}</h1>
            <div className="description" dangerouslySetInnerHTML={createMarkup()}></div>
            <div className="price">
              <p>Cena:</p>
              <div className="right shopItemPrice">{
                  typeof this.state.product.discount !== "undefined"
                    ? <div>
                        <span className="st">{this.state.product.originalPrice}
                          Kč</span>
                        <span className="red">{this.state.product.price}
                          Kč</span>
                      </div>
                    : this.state.product.price + " Kč"
                }</div>
            </div>
          </div>
          {Parameters}
          <div className="buyButton">
            <div className="addedToCart" ref="addedToCart">Zboží bylo přidáno do košíku.<i className="fas fa-check"></i></div>
            <i className="fas fa-cart-plus"></i>
            Vložit do košíku

            <input value={this.state.addAmount} onChange={this.handleAddAmount}/>
            Ks
            <div className="buyButtonClick" onClick={this.handleAddToCart}></div>

          </div>

        </div>
        <div className="col50 mobileProductDetailsImage">
          <div className="square">
            <div className="squareContent">{
                typeof this.state.product.images[0] === "undefined"
                  ? ""
                  : <img ref="bigImage2" alt="" className="imageLoading" src={"/img/products/" + this.state.product.images[0]} onClick={this.openLightbox} onLoad={this.handleImageLoaded}/>
              }</div>
          </div>
          <div>{aImages}</div>
        </div>
      </div>
    </div>);
  }
}
function mapStateToProps(state) {
  return {admin: state.admin, menuPosition: state.menuPosition};
}
export default connect(mapStateToProps)(Product);



// WEBPACK FOOTER //
// ./src/pages/Product.js